'use client';
import React, { ReactNode, createContext, useContext } from 'react';
import useMobileMediaQuery from '@components/Hooks/useMobileMediaQuery';

type AppContextValue = {
  isMobileView: boolean;
  isLoggedIn: boolean;
};

const AppContext = createContext<AppContextValue | null>(null);

export function AppContextProvider({
  children,
  isMobileUserAgent,
  isLoggedIn,
}: {
  children?: ReactNode;
  isMobileUserAgent: boolean;
  isLoggedIn: boolean;
}) {
  const isMobileView = useMobileMediaQuery(isMobileUserAgent);

  return (
    <AppContext.Provider value={{ isMobileView, isLoggedIn }}>
      {children}
    </AppContext.Provider>
  );
}

export function useAppContext() {
  const appContext = useContext(AppContext);
  if (!appContext) {
    throw new Error('useAppContext must be used within the AppContextProvider');
  }
  return appContext;
}
